import { UserRole } from '@depanneo/types'
import { requiredRoles } from '@/shared/utils/require-roles'
import { createFileRoute } from '@tanstack/react-router'
import { technicianKeys } from '@/hooks/technicians'
import { getTechnicianById } from '@/api/technicians-api'
import TechnicianDetail from '@/pages/technicians/technician-details'

export type TechnicianTabs =
  | 'details'
  | 'facturation'
  | 'contacts'
  | 'horaires-zones'
  | 'documents'
  | 'notes'
  | 'factures'
  | 'interventions'
  | 'signalements'
  | 'signature'

const allowedTabs: TechnicianTabs[] = [
  'details',
  'facturation',
  'contacts',
  'horaires-zones',
  'documents',
  'notes',
  'factures',
  'interventions',
  'signalements',
  'signature',
]

export type TechnicianSearch = {
  tab: TechnicianTabs
  action?: 'edit'
  page?: number
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/technicians/$technicianId'
)({
  component: TechnicianDetail,
  validateSearch: (search: Record<string, unknown>): TechnicianSearch => {
    const { tab, action, page } = search

    const validatedTab = allowedTabs.includes(tab as TechnicianTabs)
      ? (tab as TechnicianTabs)
      : 'details'

    const validatedPage =
      typeof page === 'number' && page > 0 ? page : undefined

    return {
      tab: validatedTab,
      action: action === 'edit' ? 'edit' : undefined,
      page: validatedPage,
    }
  },
  beforeLoad() {
    requiredRoles([UserRole.SUPER_ADMIN])
  },
  loader: async ({ context: { queryClient }, params: { technicianId } }) =>
    queryClient.ensureQueryData({
      queryKey: technicianKeys.detail(technicianId),
      queryFn: () => getTechnicianById(technicianId),
    }),
})
